import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L17.5858 5H14ZM3.87868 5.87868C4.44129 5.31607 5.20435 5 6 5H10C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7H6C5.73478 7 5.48043 7.10536 5.29289 7.29289C5.10536 7.48043 5 7.73478 5 8V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H16C16.2652 19 16.5196 18.8946 16.7071 18.7071C16.8946 18.5196 17 18.2652 17 18V14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V18C19 18.7957 18.6839 19.5587 18.1213 20.1213C17.5587 20.6839 16.7957 21 16 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V8C3 7.20435 3.31607 6.44129 3.87868 5.87868Z"
    />
  </svg>
);

const ExternalLinkIcon = (props) => <Icon component={SVG} {...props} />;

export default ExternalLinkIcon;
